<style>
  .i-navbar {
    position: fixed;
    width: 100%;
    z-index: 1500;
    top: 0;
  }

  .sidebar {
    position: fixed;
  }

  .content {
    padding: 15px;
    background-color: #ffffff;
    min-height: 100%;
    padding-top: 50px;
  }

  .outlet-wrapper {
    padding-top: 70px;
  }
</style>

<div class="dashboard-wrapper">
  <div class="i-navbar">
    <irembogov-navbar
      [navbarItems]="
        selectedOrganization && selectedOrganization.acronym ? navbarItems : []
      "
      [showActiveRole]="false"
      [navbarActions]="navbarActions"
      [selectedOrganization]="selectedOrganization">
      <irembogov-navbar-profile-section
        profile
        profileLinkText="Edit Profile"
        [username]="
          (userProfile?.firstName ?? '') + ' ' + (userProfile?.lastName ?? '')
        "
        [roles]="userRoles"
        [activeRole]="currentRole?.name"
        [updatedProfile]="profileImage"
        (logout)="logoutUser()"
        (profileClick)="onProfileClick()"
        (roleChange)="roleChange($event)"
        [showDropdownUserDetails]="true"
        [showDropdownEmail]="false"
        [dropDownCustomCss]="'org-portal-dd'">
      </irembogov-navbar-profile-section>
    </irembogov-navbar>
  </div>
  <div class="outlet-wrapper">
    <router-outlet></router-outlet>
  </div>
</div>
<irembogov-toast aria-live="polite" aria-atomic="true"></irembogov-toast>
